<div mat-dialog-title>Unterschrift</div>
<div mat-dialog-content>
    <kiene-qr-code-sign-field [signature]="signature"></kiene-qr-code-sign-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Schlie&szlig;en</button>
</div>
